import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, mergeProps as _mergeProps, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder"]

import { ref, computed } from 'vue';
import stylesJS from '@/assets/styles.js';


export default /*@__PURE__*/_defineComponent({
  __name: 'inputLineNew2',
  props: /*@__PURE__*/_mergeModels({
  styles: {
    type: String,
    default: ""
  },
  placeholder: {
    type: String,
    default: ""
  },
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {

    // @input=""
    // @mouseover=""
    // @mouseleave=""
    // @focus=""
    // @blur=""
    // @click=""
    // @keydown.backspace=""
    // @keyup.enter=""
const props = __props

const inputValue = _useModel(__props, "modelValue");
const innerRef = ref(null)

const classList = computed(() => {
  // Import & defaults
  let importOBJ = stylesJS.get(props.styles)
  let iAlign = importOBJ.align || "l"
  iAlign = "align-" + iAlign
  let iMain = importOBJ.main || "h"
  iMain = "main-" + iMain
  let iBg = importOBJ.bg || "0"
  iBg = "bg-" + iBg
  let iFont = importOBJ.font || "m"
  iFont = "font-" + iFont
  let iPad = importOBJ.pad  || "m"
  iPad = "pad-" + iPad
  let iPLeft = importOBJ.pleft  || "08"
  iPLeft = "pleft-" + iPLeft
  let iBorder = importOBJ.border  || "none"
  iBorder = "border-" + iBorder  
  let iRnd = importOBJ.rnd  || "0"
  iRnd = "rnd-" + iRnd  

  return ['component', iBorder, iRnd, iMain, iAlign, iBg, iFont, iPad, iPLeft]
})

__expose({
  innerRef
})


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", _mergeProps({
    type: "text",
    ref_key: "innerRef",
    ref: innerRef
  }, _ctx.$attrs, {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
    placeholder: __props.placeholder,
    class: classList.value
  }), null, 16, _hoisted_1)), [
    [_vModelText, inputValue.value]
  ])
}
}

})